export default [
  {
    name: 'feedback_and_suggestions',
    path: '/feedback_and_suggestions',
    meta: {
      auth: false
    },
    component: () =>
      import(/* webpackChunkName: "FeedbackAndSuggestions" */ './index.vue')
  }
]
